import {Component, Input, OnInit} from '@angular/core';

export enum AlertType {
    ALERT_INFO = 'info',
    ALERT_WARNING = 'warning',
    ALERT_DANGER = 'danger',
    ALERT_SUCCESS = 'success',
}

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss']
})

export class AlertComponent implements OnInit {
    @Input() alertType?: AlertType = AlertType.ALERT_INFO;

    constructor() {
    }

    ngOnInit() {
    }

    getAlertClass(alertType) {
        switch (alertType) {
            case AlertType.ALERT_INFO:
                return 'alert-info';
            case AlertType.ALERT_WARNING:
                return 'alert-warning';
            case AlertType.ALERT_DANGER:
                return 'alert-danger';
            case AlertType.ALERT_SUCCESS:
                return 'alert-success';
            default:
                return 'alert-info';
        }
    }

    getAlertIconClass(alertType) {
        switch (alertType) {
            case AlertType.ALERT_INFO:
                return 'icon-info';
            case AlertType.ALERT_WARNING:
                return 'icon-warning';
            case AlertType.ALERT_DANGER:
                return 'icon-danger';
            case AlertType.ALERT_SUCCESS:
                return 'icon-success';
            default:
                return 'icon-info';
        }
    }
}
